<template>
   <div class="order-details-info">
      <div class="grid-row">
        <div class="c-4 c-xs-12 c-sm-6 c-md-4 c-lg-4">
          <div class="details-block">
            <span class="details-title">{{$_('your_order').toUpperCase()}}</span>
            <div class="details-info">
              <span><strong>{{$_('amount')}} : {{tmont}} {{tcdev}}</strong></span>
              <span>{{$_('incoterm')}} : {{tlib_port}} </span>
              <span>{{$_('payment')}} : {{tlib_modp}}</span>
            </div>
          </div>
        </div>
        <div class="c-4 c-xs-12 c-sm-6 c-md-4 c-lg-4">
          <div class="details-block">
            <span class="details-title">{{$_('delivery_address').toUpperCase()}}</span>
            <div class="details-info">
              <span>{{tadr1l}}</span>
              <span>{{tadr2l}}</span>
              <span>{{tadr3l}}</span>
              <span>{{tadr4l}}</span>
              <span>{{tadr5l}}</span>
              <span>{{tcpl}} {{tvillel}}</span>
            </div>
          </div>
        </div>
       <div class="c-4 c-xs-12 c-sm-12 c-md-4 c-lg-4">
          <div class="details-block">
            <span class="details-title">{{$_('approach_and_modification').toUpperCase()}}</span>
            <div class="details-info">
              <div class="btn-info-container">
                <router-link :to="{name: 'invoice', query: {order_id: this.$route.params.order_id}}" class="btn">{{$_('invoice').toUpperCase()}}</router-link>
              </div>
              <div class="btn-info-container">
                <router-link :to="{name: 'delivery', query: {order_id: this.$route.params.order_id}}" class="btn">{{$_('delivery_form').toUpperCase()}}</router-link>
              </div>
            </div>
            <span class="details-title">{{$_('download').toUpperCase()}}</span>
            <div class="details-info">
              <div class="btn-info-container">
                <a @click="getDownloadOrderRecipe" class="btn">{{$_('order_acknowledgment').toUpperCase()}}</a>
              </div>
              <div class="btn-info-container">
                <a @click="getDownloadOrderConfirm" class="btn">{{$_('order_confirmation').toUpperCase()}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>

import orderService from '@/modules/commande/services/orderService.js';

export default {
  name: 'OrderDetailsInfo',
  data() {
    return {
      tadr1l: '',
      tadr2l: '',
      tadr3l: '',
      tadr4l: '',
      tadr5l: '',
      tcpl: '',
      tport: '',
      tlib_port: '',
      tvillel: '',
      tlpaysl: '',
      tmodp: '',
      tlib_modp: '',
      tprovl: '',
      tref: '',
      tmont: '',
      tcdev: this.$store.getters['application/get_application_customer'].TCDEV
    }
  },
  created() {
    let pnocde = this.$route.params.order_id

    orderService.getOrderDetailsInfo(pnocde)
    .then(res => {
      if(res.data.DS_O !== undefined) { 
        Object.entries(res.data.DS_O.OUT).map((value) => {
          this[value[0].toLowerCase()] = value[1];            
        });
      }

    }).catch(err => {
      console.error(err);
    });
  },
  methods: {
    getDownloadOrderRecipe() {

      let pnocde = this.$route.params.order_id

      orderService.getDownloadOrderRecipe(pnocde)
      .then(res => {
        if(res.data !== undefined) {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'accuse-reception-commande-'+this.$route.params.order_id+'.pdf');
          document.body.appendChild(link);
          link.click();
        }
      });
    },
    getDownloadOrderConfirm() {

      let pnocde = this.$route.params.order_id

      orderService.getDownloadOrderConfirm(pnocde).then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'confirmation-commande.pdf');
        document.body.appendChild(link);
        link.click();
      })
    }
  }
}
</script>

<style scoped>
.order-details-info {
  padding: 10px;
  margin: 30px 0px;
}
.details-block {
  flex-direction: column;
  display: flex;
  color: #585858
}
.details-title {
  font-weight: bold; 
  margin-bottom: 15px;
  color: rgb(142, 141, 141);
}
.details-info {
  display: flex;
  flex-direction: column;
}
.details-info span {
  margin-bottom: 5px;
}
.btn-info-container {
  margin-bottom: 10px;
}
</style>